import { Login } from "@standard/pages/auth";

export default Login;
